(ns common.widgets.toggle-button
  (:require ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/ToggleButton$default" :as ToggleButton]
            ["@mui/material/ToggleButtonGroup$default" :as ToggleButtonGroup]
            ["react" :as react]
            [clojure.spec.alpha :as spec]
            [uix.core :as uix :refer [$ defui]]))

(spec/def :toggle-button/value any?)
(spec/def :toggle-button/label string?)
(spec/def :toggle-button/icon (spec/or :string string? :element react/isValidElement))
(spec/def :toggle-button/disabled? (spec/nilable boolean?))

(spec/def :toggle-button-group/option (spec/keys :req-un [:toggle-button/value
                                                          :toggle-button/label]
                                                 :opt-un [:toggle-button/icon
                                                          :toggle-button/disabled?]))

(spec/def :toggle-button-group/options (spec/and coll?
                                                 (spec/coll-of :toggle-button-group/option)))

(spec/def :toggle-button-group/on-change (spec/nilable fn?))

(spec/def :toggle-button-group/disabled? (spec/nilable boolean?))

(spec/def :toggle-button-group/props (spec/keys :req-un [:toggle-button-group/options]
                                                :opt-un [:toggle-button-group/disabled?
                                                         :toggle-button-group/on-change]))

(defui toggle-button-group
  [{:keys [on-change options disabled? exclusive?] :as props
    :or {disabled? false
         exclusive? true}}]
  {:pre [(spec/assert :toggle-button-group/props props)]}
  ($ ToggleButtonGroup
     (-> props
         (dissoc :options :disabled? :exclusive? :error)
         (assoc :disabled disabled?
                :exclusive exclusive?
                :on-change (fn [_e v]
                             (when (and (some? v) on-change)
                               (on-change v)))))
     (for [{:keys [value label disabled? icon] :as option} options]
       ($ ToggleButton
          (-> option
              (dissoc :label :disabled? :icon)
              (assoc :key (str value)
                     :disabled disabled?
                     :data-testid (str "toggle-button-" label)))
          (if icon
            ($ Icon {:sx #js {:py 0.5
                              :height "unset"}}
               icon)
            label)))))
